module.exports = __webpack_public_path__ + "img/ic-termcond-prestige.svg";